module.exports = __webpack_public_path__ + "static/media/jenna-ivory-win.40cb7cd9.jpg";